import type { Meta, StoryObj } from "@storybook/react";

import { HeaderDecorator } from "@/__stories__/Decorator";
import { BookingStepValue } from "@/constants/Booking";
import type { BookingModalFooterProps } from "@/ui/components/schedule/booking/BookingModalFooter";
import BookingModalFooter from "@/ui/components/schedule/booking/BookingModalFooter";

const StoryMeta: Meta<BookingModalFooterProps> = {
  title: "Components/Schedule/Booking/Booking Modal Footer",
  component: BookingModalFooter,
  argTypes: {
    isFinalStep: { control: "boolean" },
    isFirstStep: { control: "boolean" },
    isForwardNavigationDisabled: { control: "boolean" },
    isLoading: { control: "boolean" },
    onBackwardPress: { action: "Backward" },
    onForwardPress: { action: "Forward" },
    step: {
      control: "select",
      options: Object.values(BookingStepValue),
    },
  },
  args: {
    step: BookingStepValue.patient,
  },
  decorators: [
    (Story) => (
      <HeaderDecorator>
        <Story />
      </HeaderDecorator>
    ),
  ],
};

type Story = StoryObj<BookingModalFooterProps>;

const Primary: Story = {};
const FirstStep: Story = {
  args: {
    isFirstStep: true,
  },
};

const FinalStep: Story = {
  args: {
    isFinalStep: true,
  },
};

const Loading: Story = {
  args: {
    isLoading: true,
  },
};

const ForwardDisabled: Story = {
  args: {
    isForwardNavigationDisabled: true,
  },
};

export { FinalStep, FirstStep, ForwardDisabled, Loading, Primary };
export default StoryMeta;
